module.exports = __webpack_public_path__ + "02_long_black.b982e6d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/02_long_black.png
// module id = 0eWy
// module chunks = 0